import keys from 'lodash-es/keys'
import * as React from 'react'

import { config } from '../../../../common/config'
import { ISeoItem } from '../../../../typings/seoMetadata'
import SectionDescription from '../sectionDescription'
import TutorialPost from '../tutorialPost'

import * as styles from './tutorialsSection.module.css'

interface IProps {
  metadata: ISeoItem
}

const TutorialsSection = ({ metadata }: IProps) => {
  const { posts } = metadata
  const tutorialPostComponents =
    posts &&
    keys(posts).map((key, index) => {
      const post = posts[key]
      return (
        <TutorialPost
          imgSrc={`${config.assets.PUBLIC_PATH}/images/home-page/tutorials/${key}.jpg`}
          title={post.link_text}
          link={post.link_url}
          description={post.description}
          key={index}
          hideOnMobile={index !== 0}
        />
      )
    })

  return (
    <div className={styles.root} data-test-selector="tutorialsSection">
      <SectionDescription hideOnMobile metadata={metadata} HTag="h3" />
      <div className={styles.badgesList}>{tutorialPostComponents}</div>
    </div>
  )
}

export default TutorialsSection
